export const QA_NAME_CALENDAR_GRID_ITEM_CARD = 'calendarGridItemCard'
